import { FoodFactCreate } from './../../../core/model/api-response/persoanl-response-model';
import { FoodLogModel } from 'src/app/core/model/object/foodlog-model';
import {
  FoodModel,
  FoodUnitRatioModel,
  FoodFactModel,
  FoodFactsModel,
} from './../../../core/model/object/diet-food-model';
import { BottomsheetShared } from './../../general/shared/bottomsheet-shared';
import { PlanShared } from 'src/app/presentation/general/shared/plan-shared';
import { DietSearchFoodModel } from './../../../core/model/object/diet-model';
import { DietSearchMealModel } from 'src/app/core/model/object/diet-model';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { packagesFood } from './../../../core/model/api-response/plans-response-model';
import { PlansService } from 'src/app/data/repository/plans-repository/plans.service';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { CalorieCalculator } from 'src/app/utils/calorie-calculator';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { RecipeService } from 'src/app/data/repository/recipe-repository/recipe.service';
import { PlanOverviewBottomsheetShowdetailComponent } from './plan-overview-bottomsheet-showdetail/plan-overview-bottomsheet-showdetail.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

interface suggest {
  id: string;
  foods: packagesFood[];
  amount: {
    amount: number;
  }[];
}

@Component({
  selector: 'app-plan-overview-bottomsheet',
  templateUrl: './plan-overview-bottomsheet.component.html',
  styleUrls: ['./plan-overview-bottomsheet.component.scss'],
})
export class PlanOverviewBottomsheetComponent implements OnInit, OnDestroy {
  @Input() show: boolean = false;
  suggestions: suggest[] = [];
  recentPackage: DietSearchMealModel[];
  SWIPE_ACTION = { UP: 'swipeup', DOWN: 'swipedown' };
  searchText: string;
  activeSwitch: number = 0;
  dietId: string;
  meal: string;
  day: string;
  page: number = 0;
  txtQueryChanged: Subject<string> = new Subject<string>();
  query: string;
  status: 'searching' | 'suggesting';
  title: string;
  subscription: Subscription;
  showFoodFactDetail: boolean = false;
  foodFactsAmount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  isEmpty: boolean = false;
  count: number;
  sending: boolean = false;

  constructor(
    private plansService: PlansService,
    public calorieCalculator: CalorieCalculator,
    private planService: PlanService,
    private bottomsheetShared: BottomsheetShared,
    private snackBarService: SnackBarService,
    private recipeService: RecipeService,
    private matBottomSheet: MatBottomSheet
  ) {
    this.bottomsheetShared.closeBottomsheetObs$.subscribe((close) => {
      if (close) {
        this.showFoodFactDetail = false;
      }
    });
    this.planService.openTable.subscribe(() => {
      this.showFoodFactDetail = true;
    });
    this.planService.closeBottomSheet.subscribe(() => {
      this.show = false;
      this.closeBottomSheet();
    });
    this.dietId = this.plansService.dietID;
    this.meal = this.plansService.meal;
    this.day = this.plansService.selectDay;
    this.subscription = this.txtQueryChanged
      .pipe(debounceTime(800), distinctUntilChanged())
      .subscribe((data) => {
        this.getSearchData(data);
      });

    this.getSuggestions(this.page);
    this.page += 1;
    this.getSuggestions(this.page);
    this.recentPackage = this.plansService.getHistory(this.meal);
    if (this.meal == 'breakfast') {
      this.title = 'صبحانه';
    } else if (this.meal == 'snack1') {
      this.title = ' میان‌وعده اول';
    } else if (this.meal == 'lunch') {
      this.title = 'ناهار';
    } else if (this.meal == 'snack2') {
      this.title = ' میان‌وعده دوم';
    } else if (this.meal == 'dinner') {
      this.title = ' شام';
    } else if (this.meal == 'snack3') {
      this.title = ' میان‌وعده سوم';
    }
  }
  openDetail(suggest: suggest) {
    this.matBottomSheet.open(PlanOverviewBottomsheetShowdetailComponent, {
      panelClass: 'custom-bottomsheet-container',
      data: {
        suggest,
        title: this.title,
        day: this.day,
        meal: this.meal,
        dietId: this.dietId,
      },
    });
  }
  ngOnInit() {}
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  removeItem(id: string, meal: string) {
    this.plansService.removeRecent(id, meal);
    this.recentPackage = this.plansService.getHistory(this.meal);
  }
  closeBottomSheet() {
    setTimeout(() => {
      this.plansService.closeBottomSheet();
    }, 500);
  }
  search(query: string) {
    query = query.trim();
    this.query = query;
    if (query.length <= 0 || query === '') {
      this.suggestions = [];
      this.getSuggestions(this.page);
    } else {
      this.txtQueryChanged.next(query);
    }
  }
  onkeydown(e: KeyboardEvent) {
    if (
      (e.key == 'Backspace' && this.query.length <= 0) ||
      (this.query === '' && this.status !== 'searching')
    ) {
      this.suggestions = [];
      this.getSuggestions(this.page);
    }
  }

  MergePackageFood(data: suggest) {
    const title = data.foods.map((food) => food.foodId.name);
    return title.join(' , ');
  }
  getSuggestions(page: number) {
    this.sending = true;
    this.status = 'suggesting';
    this.plansService
      .getSuggestion(this.dietId, this.meal, page, this.day)
      .then((res) => {
        this.sending = false;
        res
          .getData()
          .getSuggetions()
          .packages.map((f) => {
            this.suggestions.push({
              id: f._id,
              foods: f.foods,
              amount: f.amounts,
            });
          });
        this.count = res.getData().getSuggetions().count;
      });
  }
  goToRecipe(id: string) {
    this.recipeService.goToRecipeDetail(id);
  }
  scrool() {
    const suggestEl = document.getElementById('suggest-body');

    if (
      suggestEl.scrollTop + suggestEl.clientHeight >=
      suggestEl.scrollHeight - 100
    ) {
      if (!this.sending && this.count && this.count > this.suggestions.length) {
        this.page += 1;
        this.getSuggestions(this.page);
      }
    }
  }
  getSearchData(data: string) {
    this.status = 'searching';
    this.isEmpty = false;

    this.plansService
      .searchPackage(this.dietId, this.meal, data, this.day)
      .then((res) => {
        if (res.isSuccess()) {
          if (res.getData().getSuggetions().packages.length == 0) {
            this.isEmpty = true;
          }
          this.suggestions = res
            .getData()
            .getSuggetions()
            .packages.map((f) => {
              return {
                foods: f.foods,
                amount: f.amounts,
                id: f._id,
              } as suggest;
            });
        }
      })
      .catch((e) => {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      });
  }
  swipe(action: string = this.SWIPE_ACTION.DOWN) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.show = false;
      this.closeBottomSheet();
    }
  }
  switcher(id: number) {
    if (id == 0) {
      this.activeSwitch = 0;
    } else {
      this.activeSwitch = 1;
    }
  }
}
